"use client";

import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useRef, useState } from "react";
import IconButton from "src/components/common/IconButton/IconButton";
import { errorToast } from "src/components/common/Toasts/ToastActions";
import { useExtracted } from "#i18n";

/** Copies the text of the code block it sits in (DocsCodeBlock). */
export default function CopyCodeButton({ className }: { className?: string }) {
  const translateMessage = useExtracted();
  const [copied, setCopied] = useState(false);
  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  const copy = async (event: React.MouseEvent<HTMLElement>) => {
    const code = event.currentTarget.closest("[data-docs-code-block]")?.querySelector("pre");
    try {
      await navigator.clipboard.writeText(code?.textContent ?? "");
      setCopied(true);
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      errorToast(translateMessage("Could not copy the code"));
    }
  };

  return (
    <IconButton
      label={copied ? translateMessage("Copied") : translateMessage("Copy code")}
      variant="bare"
      size="sm"
      className={className}
      onClick={copy}
    >
      {copied ? <IconCheck aria-hidden size={16} /> : <IconCopy aria-hidden size={16} />}
    </IconButton>
  );
}
